import { countryCodes } from '../localization';
const getDefaultCurrencyCode = (countryCode: string, countryCurrency: { currency: string[] }) => {
  const defaultCode =
    countryCurrency?.currency && countryCurrency?.currency.indexOf('USD') >= 0
      ? 'USD'
      : countryCurrency?.currency[0];
  return countryCodes[countryCode]['currencyCode'] &&
    countryCurrency?.currency.indexOf(countryCodes[countryCode]['currencyCode']) >= 0
    ? countryCodes[countryCode]['currencyCode']
    : defaultCode;
};

export const getCurrencyCode = (
  countryCode: string,
  countryCurrency: { currency: string[] } | null
) => {
  if (!countryCurrency?.currency) {
    return countryCodes[countryCode]['currencyCode'];
  }
  return countryCurrency?.currency.length === 1
    ? countryCurrency?.currency[0]
    : getDefaultCurrencyCode(countryCode, countryCurrency);
};

export function getSymbol(countryCode: string, currencyCode: string) {
  return (0)
    .toLocaleString(countryCodes[countryCode]['locale'], {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 0,
      currencyDisplay: 'narrowSymbol',
      useGrouping: false,
      signDisplay: 'never',
    })
    .replace(/[\d\s\-.,]+/, '');
}
